import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { b as i, c as t, d as b } from "../../vendor-Dd6qj6gJ.js";
import { Input as d } from "../Input/index.js";
import { c as a } from "../../styles.module-C5RaAp_v.js";
function r({ label: e, className: l, ...c }) {
  return /* @__PURE__ */ s(i, { ...c, className: b(a.colorField, l), children: [
    /* @__PURE__ */ o(d, { className: a.colorFieldInput }),
    /* @__PURE__ */ o(t, { className: a.colorFieldLabel, children: e })
  ] });
}
function x() {
  return /* @__PURE__ */ s("div", { className: a.colorFields, children: [
    /* @__PURE__ */ o(r, { label: "Hex", colorSpace: "hsb", className: a.hex }),
    ["hue", "saturation", "brightness"].map((e) => /* @__PURE__ */ o(
      r,
      {
        "aria-label": `${e} value`,
        label: e.charAt(0).toUpperCase(),
        colorSpace: "hsb",
        className: a[e],
        channel: e
      },
      e
    ))
  ] });
}
export {
  x as ColorFields
};
